import { ApiResponse, baseUrl, getWithAuth, Guid } from "./baseApi";
import { CampaignPeriod, CampaignStatus } from "./campaingsApi";

type DashboardDataResponse = {
    data: {
        channels: DashboardResponse[],
        campaignsStatistic: Statistic,
    }
    ok:"string"
}

export type CampaignsStatistic = {
    campaignsStatistic: Statistic
}

export type Statistic = {
    total: number,
    active: number,
    expired: number,
    scheduled: number,
    draft: number,
    paused: number
}

export type DashboardData ={
    channels: DashboardResponse[]
}

export type DashboardResponse ={
    channel: string,
    channelId: Guid,
    campaigns: Campaign[],
}

type Campaign = {
    campaign: string,
    channelId: Guid,
    periods: CampaignPeriod []
    status: CampaignStatus
}

export const getDashboardDiagramItems = async ():Promise<ApiResponse<DashboardDataResponse>> => {
    return await getWithAuth<DashboardDataResponse>({url: `${baseUrl}dashboard`});
}
